import DocumentTitle from 'react-document-title';
import { Routes as ReactRouterRoutes, Route } from 'react-router-dom';

import MediaCenterContainer from 'hb-react/frontoffice/apps/MediaCenter/container';
import { MediaCenterCategoriesProvider } from 'hb-react/frontoffice/apps/MediaCenter/contexts/MediaCenterCategoriesContext';
import { MediaCenterPathProvider } from 'hb-react/frontoffice/apps/MediaCenter/contexts/MediaCenterPathContext';
import { getPageTitle } from 'hb-react/frontoffice/utils/page';

const MediaCenterApp = ({ configPage, topic, configUrls }) => (
  <>
    <DocumentTitle title={getPageTitle({ featureName: 'media_center' })} />
    <ReactRouterRoutes>
      {[
        `/file/:fileUuid`,
        `/folder/:folderUuid`,
        `/folders/:folderUuid`,
        `/`,
      ].map((path) => (
        <Route
          key={path}
          path={path}
          element={
            <MediaCenterPathProvider configUrls={configUrls}>
              <MediaCenterCategoriesProvider topic={topic}>
                <MediaCenterContainer topic={topic} configPage={configPage} />
              </MediaCenterCategoriesProvider>
            </MediaCenterPathProvider>
          }
        />
      ))}
    </ReactRouterRoutes>
  </>
);

export default MediaCenterApp;
